import React, { useState } from "react";
import Header from "../components/Header";
import Header2 from "../components/Header2";
import Footer from "../components/Footer";

import "../assets/css/bootstrap.min.css";
import "../assets/css/style.css";
import "../assets/css/menu.css";
import "../assets/css/vendors.css";
import "../assets/css/icon_fonts/css/all_icons_min.css";
import "../assets/css/custom.css";

const doctorsData = [
  {
    name: "Dr. Priya Sharma",
    qualification: "MBBS, MS - General Surgery, MCh - Plastic Surgery",
    fee: " FREE Consultation",
    rating: "4.8/5",
    experience: "15 Years Experience",
    location: "2nd Floor, MS Tower, Banjara Hills, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "Earlobe Repair Specialist"
  },
  {
    name: "Dr. Anjali Mehta",
    qualification: "MBBS, MD - Dermatology, Fellowship in Cosmetic Surgery",
    fee: " FREE Consultation",
    rating: "4.9/5",
    experience: "12 Years Experience",
    location: "Apurupa Urban, No 201, 2nd Floor, Image Gardens Rd, near Chirec School, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Cosmetic Earlobe Restoration Expert"
  },
  {
    name: "Dr. Rohan Verma",
    qualification: "MBBS, MS - General Surgery, MCh - Plastic Surgery",
    fee: " FREE Consultation",
    rating: "4.7/5",
    experience: "14 Years Experience",
    location: "Annapurna Kalyana Mandapam Srinagar Nagar, Dilsukhnagar, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "Advanced Earlobe Reconstruction Expert"
  },
  {
    name: "Dr. Sneha Reddy",
    qualification: "MBBS, MD - Dermatology, Fellowship in Aesthetic Medicine",
    fee: " FREE Consultation",
    rating: "4.6/5",
    experience: "11 Years Experience",
    location: "123 Green Avenue, Banjara Hills, Hyderabad",
    phone: "080-6541-7710",
    online: false,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Minimal Scar Earlobe Repair Specialist"
  },
  {
    name: "Dr. Kavita Patel",
    qualification: "MBBS, MS - General Surgery, MCh - Plastic Surgery",
    fee: " FREE Consultation",
    rating: "4.8/5",
    experience: "16 Years Experience",
    location: "45 Tower Road, Jubilee Hills, Hyderabad",
    phone: "080-6541-7720",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "Complex Earlobe Reconstruction Expert"
  },
  {
    name: "Dr. Arjun Kumar",
    qualification: "MBBS, DNB - Plastic Surgery",
    fee: "FREE Consultation",
    rating: "4.7/5",
    experience: "13 Years Experience",
    location: "21 MG Road, Hyderabad",
    phone: "080-6541-7730",
    online: false,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Earlobe Repair & Restoration Specialist"
  },
];

const DoctorsSection = () => {
  const [showAll, setShowAll] = useState(false);
  const displayedDoctors = showAll ? doctorsData : doctorsData.slice(0, 6);

  return (
    <div style={{ padding: "80px 20px", backgroundColor: "#f8f9fa" }}>
      <div style={{ maxWidth: "1200px", margin: "0 auto", fontFamily: "'Poppins', sans-serif" }}>
        <div style={{ textAlign: "center", marginBottom: "50px" }}>
          <h2 style={{ fontSize: "42px", fontWeight: "800", color: "#0b1c39", marginBottom: "15px" }}>
            Our <span style={{ color: "#ffcb24" }}>Earlobe Repair Specialists</span>
          </h2>
          <p style={{ fontSize: "18px", color: "#555", maxWidth: "600px", margin: "0 auto", lineHeight: "1.8" }}>
            Expert surgical care for torn, stretched, and damaged earlobes with natural-looking restoration and minimal scarring.
          </p>
        </div>

        <div style={{ display: "flex", flexWrap: "wrap", gap: "25px", justifyContent: "space-between" }}>
          {displayedDoctors.map((doc, index) => (
            <div
              key={index}
              style={{
                flex: "0 0 calc(33.33% - 17px)",
                backgroundColor: "#fff",
                borderRadius: "16px",
                padding: "25px",
                boxShadow: "0 8px 30px rgba(0,0,0,0.08)",
                display: "flex",
                alignItems: "center",
                gap: "20px",
                border: "1px solid rgba(9,187,175,0.1)",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow = "0 12px 35px rgba(0,0,0,0.12)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 8px 30px rgba(0,0,0,0.08)";
              }}
            >
              <div style={{ position: "relative", flexShrink: 0 }}>
                <img
                  src={doc.image}
                  alt={doc.name}
                  style={{
                    width: "95px",
                    height: "95px",
                    borderRadius: "50%",
                    objectFit: "cover",
                    border: "3px solid #09bbaf",
                    backgroundColor: "#f8f8f8",
                  }}
                />
                {doc.online && (
                  <span
                    style={{
                      position: "absolute",
                      bottom: "8px",
                      right: "8px",
                      width: "14px",
                      height: "14px",
                      backgroundColor: "#09bbaf",
                      borderRadius: "50%",
                      border: "2px solid #fff",
                    }}
                    title="Online"
                  ></span>
                )}
              </div>

              <div style={{ flex: 1 }}>
                <h3 style={{ fontSize: "18px", fontWeight: "700", color: "#0b1c39", marginBottom: "6px" }}>
                  {doc.name}
                </h3>
                <p style={{ color: "#09bbaf", fontSize: "14px", marginBottom: "6px", fontWeight: "600" }}>
                  {doc.specialization}
                </p>
                <p style={{ color: "#555", fontSize: "14px", marginBottom: "6px" }}>
                  {doc.qualification}
                </p>
                <p style={{ fontWeight: "600", color: "#09bbaf", marginBottom: "6px", fontSize: "15px" }}>
                  {doc.fee}
                </p>
                <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "6px" }}>
                  <span style={{ fontSize: "14px", color: "#555" }}>⭐ {doc.rating}</span>
                  <span style={{ fontSize: "14px", color: "#555" }}>{doc.experience}</span>
                </div>
                <p style={{ fontSize: "13px", color: "#555", display: "flex", alignItems: "flex-start", gap: "6px", marginBottom: "6px", lineHeight: "1.4" }}>
                  📍 {doc.location}
                </p>
                <p style={{ fontSize: "13px", color: "#555", marginBottom: "15px" }}>
                  📞 {doc.phone}
                </p>

                <button
                  style={{
                    padding: "12px 20px",
                    border: "none",
                    borderRadius: "30px",
                    backgroundColor: "#ffcb24",
                    color: "#0b1c39",
                    cursor: "pointer",
                    width: "100%",
                    fontWeight: "600",
                    fontSize: "14px",
                    transition: "background-color 0.3s ease",
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#ffd84f")}
                  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#ffcb24")}
                >
                  Book Free Consultation
                </button>
              </div>
            </div>
          ))}
        </div>

        {!showAll && doctorsData.length > 6 && (
          <div style={{ textAlign: "center", marginTop: "40px" }}>
            <button
              onClick={() => setShowAll(true)}
              style={{
                padding: "14px 40px",
                fontSize: "16px",
                borderRadius: "12px",
                border: "none",
                backgroundColor: "#09bbaf",
                color: "#fff",
                cursor: "pointer",
                fontWeight: "700",
                boxShadow: "0 8px 25px rgba(9,187,175,0.3)",
                transition: "background-color 0.3s ease",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#0dcfc2")}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#09bbaf")}
            >
              View More Doctors ▼
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

const EarlobeRepair = () => {
  const [activeTab, setActiveTab] = useState("overview");

  return (
    <>
      <Header />
      <Header2 />

      {/* Hero Section */}
      <section style={{
        background: "linear-gradient(135deg, #0b1c39 0%, #09bbaf 100%)",
        padding: "160px 0 100px",
        marginTop: "56px",
        color: "white",
        textAlign: "center",
        position: "relative",
        overflow: "hidden"
      }}>
        <div className="container" style={{ position: "relative", zIndex: 2 }}>
          <h1 style={{
            fontSize: "3.5rem",
            fontWeight: "800",
            marginBottom: "20px",
            color: "white"
          }}>
            Advanced Earlobe Repair Surgery
          </h1>
          <p style={{
            fontSize: "1.3rem",
            marginBottom: "30px",
            opacity: "0.9",
            maxWidth: "700px",
            margin: "0 auto 30px",
            lineHeight: "1.6"
          }}>
            Complete Earlobe Restoration with 98% Success Rate. Permanent Solution for Torn, Stretched, and Damaged Earlobes.
          </p>
          <div style={{ display: "flex", justifyContent: "center", gap: "20px", flexWrap: "wrap" }}>
            <button style={{
              padding: "15px 35px",
              borderRadius: "30px",
              border: "none",
              backgroundColor: "#ffcb24",
              color: "#0b1c39",
              fontWeight: "700",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffd84f";
              e.currentTarget.style.transform = "translateY(-2px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.transform = "translateY(0)";
            }}>
              Book Free Consultation
            </button>
            <button style={{
              padding: "15px 35px",
              borderRadius: "30px",
              border: "2px solid #ffcb24",
              backgroundColor: "transparent",
              color: "#ffcb24",
              fontWeight: "700",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.color = "#0b1c39";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "transparent";
              e.currentTarget.style.color = "#ffcb24";
            }}>
              Emergency Earlobe Repair
            </button>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section style={{ backgroundColor: "#fff", padding: "60px 0", borderBottom: "1px solid #eee" }}>
        <div className="container">
          <div className="row">
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>98%</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Surgical Success Rate</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>20-45</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Minutes Procedure Time</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>1-2</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Weeks Full Recovery</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>{`<1%`}</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Complication Rate</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Doctors Section */}
      <DoctorsSection />

      {/* Navigation Tabs */}
      <section style={{ backgroundColor: "#fff", padding: "40px 0", borderBottom: "1px solid #eee" }}>
        <div className="container">
          <div style={{ display: "flex", justifyContent: "center", gap: "10px", flexWrap: "wrap" }}>
            {[
              { id: "overview", label: "Overview", icon: "📋" },
              { id: "causes", label: "Causes", icon: "🔍" },
              { id: "types", label: "Repair Types", icon: "🎯" },
              { id: "procedure", label: "Procedure", icon: "🔬" },
              { id: "recovery", label: "Recovery", icon: "⚕️" },
              { id: "results", label: "Results", icon: "🔄" },
              { id: "faq", label: "FAQ", icon: "🛡️" }
            ].map(tab => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                style={{
                  padding: "12px 24px",
                  borderRadius: "25px",
                  border: "none",
                  backgroundColor: activeTab === tab.id ? "#09bbaf" : "#f8f9fa",
                  color: activeTab === tab.id ? "white" : "#555",
                  fontWeight: "600",
                  cursor: "pointer",
                  transition: "all 0.3s ease"
                }}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Main Content */}
      <div className="container" style={{ padding: "80px 15px" }}>

        {/* Comprehensive Overview */}
        <section style={{ marginBottom: "80px" }}>
          <div style={{ textAlign: "center", marginBottom: "60px" }}>
            <h2 style={{ fontSize: "36px", fontWeight: "800", color: "#0b1c39", marginBottom: "20px" }}>
              Complete Guide to <span style={{ color: "#09bbaf" }}>Earlobe Repair Surgery</span>
            </h2>
          </div>

          {/* What is Earlobe Repair */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "50px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
              border: "1px solid rgba(9,187,175,0.1)"
            }}>
              <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "30px" }}>
                Understanding Earlobe Repair (Lobuloplasty)
              </h3>
              
              <p style={{ color: "#555", lineHeight: "1.8", fontSize: "1.1rem", marginBottom: "25px" }}>
                Earlobe repair, medically known as lobuloplasty, is a specialized cosmetic surgical procedure 
                designed to correct various types of earlobe damage and deformities. This includes repairing 
                torn, stretched, split, or gauged earlobes resulting from trauma, heavy earrings, aging, 
                or body modification. The procedure restores the natural appearance and integrity of the earlobe 
                while allowing for future ear piercing if desired.
              </p>

              <div className="row">
                <div className="col-md-6">
                  <div style={{
                    backgroundColor: "#f8f9fa",
                    borderRadius: "15px",
                    padding: "25px",
                    borderLeft: "4px solid #09bbaf",
                    marginBottom: "25px"
                  }}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px" }}>Common Issues Addressed</h5>
                    <p style={{ color: "#555", margin: 0 }}>
                      Torn earlobes from trauma or earring pull, stretched lobes from heavy earrings, 
                      split lobes from gauging, elongated piercing holes, and congenital earlobe deformities.
                    </p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{
                    backgroundColor: "#f8f9fa",
                    borderRadius: "15px",
                    padding: "25px",
                    borderLeft: "4px solid #ffcb24",
                    marginBottom: "25px"
                  }}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px" }}>Restoration Benefits</h5>
                    <p style={{ color: "#555", margin: 0 }}>
                      Natural earlobe contour restoration, ability to wear earrings again, improved aesthetic appearance, 
                      increased confidence, and prevention of further damage or tearing.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Common Earlobe Problems */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Common Earlobe Problems & Conditions
            </h3>

            <div className="row">
              {[
                {
                  title: "Torn Earlobes", 
                  description: "Complete or partial tears caused by earring trauma, accidental pulling, or sleeping with earrings",
                  details: "Most common reason for earlobe repair"
                },
                {
                  title: "Stretched Piercings", 
                  description: "Elongated piercing holes from heavy earrings over time or intentional stretching",
                  details: "Gradual enlargement of piercing channel"
                },
                {
                  title: "Split Earlobes", 
                  description: "Complete division of earlobe into two parts, often from gauges or significant trauma",
                  details: "Requires comprehensive reconstruction"
                },
                {
                  title: "Keloid Scars", 
                  description: "Overgrown scar tissue at piercing sites that requires surgical removal and revision",
                  details: "More common in certain ethnicities"
                },
                {
                  title: "Congenital Deformities", 
                  description: "Birth defects or unusual earlobe shapes that affect appearance and function",
                  details: "Present from birth"
                },
                {
                  title: "Age-Related Changes", 
                  description: "Elongation and thinning of earlobes due to aging, gravity, and sun damage",
                  details: "Natural aging process"
                }
              ].map((problem, index) => (
                <div key={index} className="col-lg-4 col-md-6 mb-4">
                  <div style={{
                    backgroundColor: "#fff",
                    borderRadius: "15px",
                    padding: "25px",
                    boxShadow: "0 8px 25px rgba(0,0,0,0.08)",
                    border: "1px solid rgba(9,187,175,0.1)",
                    height: "100%",
                    transition: "transform 0.3s ease"
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-5px)"}
                  onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0)"}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.2rem" }}>
                      {problem.title}
                    </h5>
                    <p style={{ color: "#555", fontSize: "1rem", lineHeight: "1.6", marginBottom: "15px" }}>
                      {problem.description}
                    </p>
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "8px",
                      padding: "12px",
                      borderLeft: "3px solid #09bbaf"
                    }}>
                      <p style={{ color: "#666", fontSize: "0.9rem", lineHeight: "1.5", margin: 0 }}>
                        {problem.details}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Repair Types & Techniques */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Earlobe Repair Techniques & Options
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              <div className="row">
                {[
                  {
                    type: "Simple Linear Repair",
                    description: "Direct closure of torn edges for clean, straight-line scars with minimal tissue removal",
                    treatment: "Ideal for fresh, clean tears without tissue loss"
                  },
                  {
                    type: "Z-Plasty Technique",
                    description: "Advanced method using Z-shaped incisions to prevent notching and distribute tension",
                    treatment: "Best for preventing scar contracture and notching"
                  },
                  {
                    type: "W-Plasty Repair",
                    description: "W-shaped incision pattern that creates irregular scar line for better camouflage",
                    treatment: "Excellent for scar concealment and natural appearance"
                  },
                  {
                    type: "V-Y Advancement",
                    description: "Tissue rearrangement technique that preserves earlobe volume and shape",
                    treatment: "Ideal for tissue conservation in complex repairs"
                  },
                  {
                    type: "Keloid Excision",
                    description: "Surgical removal of keloid tissue with specialized closure to prevent recurrence",
                    treatment: "Includes adjunct treatments to minimize regrowth"
                  },
                  {
                    type: "Staged Reconstruction",
                    description: "Multi-step approach for severe damage using tissue flaps and grafts",
                    treatment: "For complex cases with significant tissue loss"
                  }
                ].map((type, index) => (
                  <div key={index} className="col-lg-6 mb-4">
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "15px",
                      padding: "25px",
                      border: "2px solid #09bbaf",
                      height: "100%"
                    }}>
                      <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.2rem" }}>
                        {type.type}
                      </h5>
                      <p style={{ color: "#555", fontSize: "1rem", lineHeight: "1.6", marginBottom: "15px" }}>
                        {type.description}
                      </p>
                      <div style={{
                        backgroundColor: "#09bbaf",
                        color: "white",
                        padding: "8px 15px",
                        borderRadius: "20px",
                        display: "inline-block",
                        fontSize: "0.9rem",
                        fontWeight: "600"
                      }}>
                        {type.treatment}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Candidates & Considerations */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#0b1c39",
              borderRadius: "20px",
              padding: "50px",
              color: "white"
            }}>
              <h3 style={{ fontSize: "28px", fontWeight: "800", marginBottom: "30px", color: "#ffcb24" }}>
                Ideal Candidates & Treatment Considerations
              </h3>
              
              <div className="row">
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#ffcb24", fontWeight: "700", marginBottom: "15px" }}>Ideal Candidates</h5>
                    <ul style={{ color: "rgba(255,255,255,0.9)", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Individuals with torn, split, or stretched earlobes</li>
                      <li style={{ marginBottom: "10px" }}>Those with elongated piercing holes from heavy earrings</li>
                      <li style={{ marginBottom: "10px" }}>People with keloid scars or unsatisfactory piercings</li>
                      <li style={{ marginBottom: "10px" }}>Patients with congenital earlobe deformities</li>
                      <li>Those wanting to restore natural earlobe appearance</li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#ffcb24", fontWeight: "700", marginBottom: "15px" }}>Important Considerations</h5>
                    <ul style={{ color: "rgba(255,255,255,0.9)", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Overall health and healing capacity assessment</li>
                      <li style={{ marginBottom: "10px" }}>History of keloid formation or poor scarring</li>
                      <li style={{ marginBottom: "10px" }}>Timing relative to recent earring trauma or infection</li>
                      <li style={{ marginBottom: "10px" }}>Desire for future ear piercing after repair</li>
                      <li>Realistic expectations about scarring and outcomes</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Treatment Options */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Comprehensive Repair Approaches
            </h3>

            <div className="row">
              <div className="col-lg-6 mb-4">
                <div style={{
                  backgroundColor: "#fff",
                  borderRadius: "20px",
                  padding: "40px",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                  border: "2px solid #09bbaf",
                  height: "100%"
                }}>
                  <h4 style={{ color: "#0b1c39", marginBottom: "25px", fontSize: "24px", fontWeight: "800" }}>
                    Standard Earlobe Repair
                  </h4>
                  
                  <p style={{ color: "#555", lineHeight: "1.8", marginBottom: "25px" }}>
                    The standard earlobe repair procedure is a precise surgical technique performed under 
                    local anesthesia that carefully rejoins torn tissues while preserving natural earlobe 
                    contour and symmetry.
                  </p>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Surgical Steps:</h6>
                    <div className="row">
                      <div className="col-12">
                        <ul style={{ color: "#555", paddingLeft: "20px", fontSize: "0.95rem" }}>
                          <li style={{ marginBottom: "8px" }}><strong>Anesthesia:</strong> Local anesthetic injection for complete comfort</li>
                          <li style={{ marginBottom: "8px" }}><strong>Debridement:</strong> Careful removal of damaged tissue and scar tissue</li>
                          <li style={{ marginBottom: "8px" }}><strong>Incision Planning:</strong> Strategic incision design for optimal healing</li>
                          <li style={{ marginBottom: "8px" }}><strong>Layered Closure:</strong> Precise suturing in multiple tissue layers</li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Key Features:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "8px" }}><strong>Minimal Scarring:</strong> Advanced techniques for barely visible scars</li>
                      <li style={{ marginBottom: "8px" }}><strong>Symmetry:</strong> Careful attention to matching both earlobes</li>
                      <li style={{ marginBottom: "8px" }}><strong>Natural Contour:</strong> Preservation of natural earlobe shape and curve</li>
                      <li><strong>Future Piercing:</strong> Option for re-piercing after complete healing</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="col-lg-6 mb-4">
                <div style={{
                  backgroundColor: "#fff",
                  borderRadius: "20px",
                  padding: "40px",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                  border: "2px solid #ffcb24",
                  height: "100%"
                }}>
                  <h4 style={{ color: "#0b1c39", marginBottom: "25px", fontSize: "24px", fontWeight: "800" }}>
                    Complex Reconstruction & Special Cases
                  </h4>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Advanced Techniques:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px", marginBottom: "25px" }}>
                      <li style={{ marginBottom: "10px" }}><strong>Gauge Repair:</strong> Specialized reconstruction for stretched earlobes</li>
                      <li style={{ marginBottom: "10px" }}><strong>Keloid Management:</strong> Comprehensive approach including steroid injections</li>
                      <li style={{ marginBottom: "10px" }}><strong>Tissue Grafting:</strong> Using local tissue for severe volume loss</li>
                      <li style={{ marginBottom: "10px" }}><strong>Combined Procedures:</strong> Earlobe repair with facial rejuvenation</li>
                      <li><strong>Revision Surgery:</strong> Correction of previous unsatisfactory repairs</li>
                    </ul>
                  </div>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Special Considerations:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px", marginBottom: "25px" }}>
                      <li style={{ marginBottom: "10px" }}>Emergency repair for acute traumatic tears</li>
                      <li style={{ marginBottom: "10px" }}>Bilateral symmetry in one or multiple sessions</li>
                      <li style={{ marginBottom: "10px" }}>Pediatric earlobe repair for congenital issues</li>
                      <li style={{ marginBottom: "10px" }}>Earlobe reduction for disproportionately large lobes</li>
                      <li>Combination with ear reshaping procedures</li>
                    </ul>
                  </div>

                  <div>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Advanced Features:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Customized approach based on individual anatomy</li>
                      <li style={{ marginBottom: "10px" }}>Minimal downtime and rapid recovery protocols</li>
                      <li>Natural-looking results that blend seamlessly</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Surgical Procedure Timeline */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Surgical Procedure & Recovery Timeline
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              <div className="row">
                {[
                  {
                    period: "Day 1-3",
                    title: "Initial Healing",
                    activities: ["Slight swelling and bruising", "Sutures intact", "Wound care begins", "Minimal discomfort"]
                  },
                  {
                    period: "Day 4-7",
                    title: "Early Recovery",
                    activities: ["Swelling reduces", "Bruising fades", "Light activities resume", "Follow-up visit"]
                  },
                  {
                    period: "Week 2",
                    title: "Suture Removal",
                    activities: ["Sutures removed", "Scar care begins", "Normal activities", "Gentle cleaning"]
                  },
                  {
                    period: "Month 1-3",
                    title: "Scar Maturation",
                    activities: ["Scar softening", "Redness fades", "Final results visible", "Re-piercing possible"]
                  }
                ].map((stage, index) => (
                  <div key={index} className="col-lg-3 col-md-6 mb-4">
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "15px",
                      padding: "25px",
                      textAlign: "center",
                      border: "1px solid rgba(9,187,175,0.2)",
                      height: "100%"
                    }}>
                      <div style={{ 
                        backgroundColor: "#09bbaf", 
                        color: "white", 
                        width: "60px", 
                        height: "60px", 
                        borderRadius: "50%", 
                        display: "flex", 
                        alignItems: "center", 
                        justifyContent: "center", 
                        margin: "0 auto 15px",
                        fontWeight: "700",
                        fontSize: "0.9rem"
                      }}>
                        {stage.period}
                      </div>
                      <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.1rem" }}>
                        {stage.title}
                      </h5>
                      <ul style={{ color: "#555", fontSize: "0.85rem", paddingLeft: "15px", textAlign: "left" }}>
                        {stage.activities.map((activity, idx) => (
                          <li key={idx} style={{ marginBottom: "8px" }}>{activity}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Prevention & Aftercare */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
              border: "2px solid rgba(255,203,36,0.3)"
            }}>
              <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "30px", textAlign: "center" }}>
                Post-operative Care & Prevention
              </h3>

              <div className="row">
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Immediate Post-op Care</h5>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Keep wound clean and dry for first 48 hours</li>
                      <li style={{ marginBottom: "10px" }}>Apply antibiotic ointment as directed</li>
                      <li style={{ marginBottom: "10px" }}>Avoid sleeping on repaired earlobe</li>
                      <li>Attend follow-up appointment for suture removal</li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Long-term Prevention</h5>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Wait 6-8 weeks before re-piercing ears</li>
                      <li style={{ marginBottom: "10px" }}>Avoid heavy earrings that strain earlobes</li>
                      <li style={{ marginBottom: "10px" }}>Remove earrings during sleep and physical activities</li>
                      <li>Practice good scar care with silicone sheets if needed</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* FAQ Section */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Frequently Asked Questions
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              {[
                {
                  question: "How painful is earlobe repair surgery?",
                  answer: "Earlobe repair is typically very well-tolerated with minimal discomfort. The procedure is performed under local anesthesia, which completely numbs the earlobe area. Patients may feel a slight pinprick during the anesthetic injection, but the actual surgery is completely painless. After the procedure, most patients experience only mild soreness or tenderness that is easily managed with over-the-counter pain relievers like acetaminophen. The recovery involves minimal pain, usually described as mild discomfort rather than actual pain. Severe pain is uncommon and may indicate complications, which should be reported to your surgeon immediately. Most patients return to normal activities within a day or two with only minor restrictions on strenuous activities."
                },
                {
                  question: "Will I be able to wear earrings again after earlobe repair?",
                  answer: "Yes, in most cases you will be able to wear earrings again after earlobe repair. However, there is an important healing timeline to follow: The initial repair must heal completely, which takes about 6-8 weeks; Re-piercing should be done through healthy tissue, not through the repair scar; The new piercing should be placed in a slightly different location to avoid the repaired area; It's recommended to wait at least 3 months before wearing heavy earrings; Start with lightweight earrings and gradually increase weight if desired. Your surgeon will assess your specific case and provide personalized recommendations about when and how you can safely wear earrings again. Most patients successfully wear normal earrings after proper healing, though very heavy earrings may need to be avoided to prevent future damage."
                },
                {
                  question: "How long does earlobe repair surgery take?",
                  answer: "Earlobe repair is a relatively quick procedure: Simple tears typically take 20-30 minutes per earlobe; More complex repairs or reconstructions may take 45-60 minutes; Bilateral repairs (both earlobes) usually take 45-90 minutes total; The actual surgical time includes: Local anesthesia administration (5-10 minutes), Surgical repair and suturing (15-40 minutes per earlobe), Dressing application (5 minutes). Most procedures are performed as outpatient surgery in a clinical setting, and patients can go home immediately after the procedure. The entire process from check-in to discharge usually takes 1-2 hours, making it a convenient procedure that fits easily into most schedules. The quick procedure time and minimal downtime make earlobe repair one of the most efficient cosmetic surgeries available."
                },
                {
                  question: "What is the success rate of earlobe repair surgery?",
                  answer: "Earlobe repair surgery has an extremely high success rate of 98% when performed by an experienced surgeon. Success is measured by: Complete healing without complications, Restoration of natural earlobe contour, Minimal visible scarring, Patient satisfaction with aesthetic results, and Ability to wear earrings again if desired. Factors contributing to this high success rate include: The excellent blood supply to earlobe tissue promotes rapid healing, The procedure is technically straightforward for trained surgeons, Local anesthesia ensures patient comfort and cooperation, Advanced suturing techniques minimize scarring, and Proper post-operative care instructions prevent complications. While rare complications can include infection, bleeding, or unsatisfactory scarring, these are uncommon and usually manageable. Most patients are highly satisfied with their results and report significant improvement in appearance and confidence."
                },
                {
                  question: "Can earlobe repair be done on gauged or stretched ears?",
                  answer: "Yes, earlobe repair can successfully address gauged or stretched ears, though these cases require specialized techniques. The approach depends on the degree of stretching: Small gauges (up to 00G) can often be repaired with direct excision and closure; Medium gauges may require tissue rearrangement techniques like Z-plasty; Large gauges (over 1/2 inch) may need more complex reconstruction with tissue flaps; The surgical strategy involves: Removing the epithelial lining of the stretched tunnel, Bringing healthy tissue together in layers, Using advanced techniques to prevent notching, and Preserving as much natural earlobe tissue as possible. Even significantly stretched earlobes can be restored to near-normal appearance. The results are typically very natural-looking, and many patients can have their ears re-pierced after complete healing, though usually at a smaller gauge size than before."
                }
              ].map((faq, index) => (
                <div key={index} style={{ 
                  marginBottom: "25px",
                  paddingBottom: "25px",
                  borderBottom: index < 4 ? "1px solid #eee" : "none"
                }}>
                  <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "10px" }}>
                    {faq.question}
                  </h5>
                  <p style={{ color: "#555", lineHeight: "1.6", margin: 0 }}>
                    {faq.answer}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Final CTA */}
          <div style={{
            background: "linear-gradient(135deg, #0b1c39 0%, #09bbaf 100%)",
            borderRadius: "20px",
            padding: "60px 40px",
            textAlign: "center",
            color: "white"
          }}>
            <h2 style={{ fontSize: "2.5rem", fontWeight: "800", marginBottom: "20px" }}>
              Need Earlobe Repair?
            </h2>
            <p style={{ fontSize: "1.2rem", marginBottom: "30px", opacity: "0.9", maxWidth: "600px", margin: "0 auto 30px" }}>
              Our surgical team provides expert earlobe repair with natural results and rapid recovery.
            </p>
            <button style={{
              padding: "18px 45px",
              borderRadius: "30px",
              border: "none",
              backgroundColor: "#ffcb24",
              color: "#0b1c39",
              fontWeight: "800",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffd84f";
              e.currentTarget.style.transform = "translateY(-2px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.transform = "translateY(0)";
            }}>
              Book FREE Consultation Now
            </button>
            <p style={{ marginTop: "20px", fontSize: "1rem", opacity: "0.8" }}>
              Plastic Surgery: <strong>080-6541-7705</strong> | Cosmetic Dermatology: <strong>080-6541-7715</strong>
            </p>
          </div>
        </section>
      </div>

      <Footer />
    </>
  );
};

export default EarlobeRepair;